import moment from "moment";

/** Display a Date as DD/MM/YYYY (fixed format for dashboard range inputs). */
export function formatDateAsDdMmYyyy(date) {
  if (!date) return "";
  return moment(date).format("DD/MM/YYYY");
}

/**
 * Keep only digits and insert slashes so the user is guided to DD/MM/YYYY.
 * Max 8 digits -> DD/MM/YYYY
 */
export function formatDigitsAsDdMmYyyy(value) {
  const digits = String(value).replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
}

/** Strict parse; returns a Date or null if not a valid calendar day. */
export function parseDdMmYyyyToDate(str) {
  const s = String(str).trim();
  if (s.length !== 10) return null;
  const m = moment(s, "DD/MM/YYYY", true);
  return m.isValid() ? m.toDate() : null;
}
